let capturedToken='';
// Fragments never reach HTTP requests. Scrub before React mounts or any app
// navigation/analytics can observe them. Keep the authority in page memory only.
export function captureRecoveryLink(location,history) {
 if(location?.pathname!=='/reset-password')return '';
 const entries=new URLSearchParams((location.hash||'').replace(/^#/,''));
 const values=entries.getAll('recovery');
 const token=values.length===1&&/^[A-Za-z0-9_-]{43}$/.test(values[0])?values[0]:'';
 history.replaceState(null,'','/reset-password');
 return token;
}
export function prepareRecoveryLink(){if(typeof window!=='undefined')capturedToken=captureRecoveryLink(window.location,window.history);}
export const getRecoveryToken=()=>capturedToken;
export const forgetRecoveryToken=()=>{capturedToken='';};
